// Where we work interactive map

$(function() {

	// Cache elements
	var $ovl = $('.overlay'),
		$ovl_image = $('.overlay-img'),
		$ovl_heading = $('.overlay-content h3'),
		$ovl_content = $('.overlay-content p'),
		$ovl_link = $('.overlay-link'),
		$ovl_next = $('.overlay-next'),
		$ovl_prev = $('.overlay-prev'),
		$ovl_filter_overlay = $('.overlay-filter-overlay'),
		$marker = $('.marker'),
		$work_map = $('.work-map'),
		$html = $('html'),
		count = $marker.length,
		active,
		map;

	map = {
		init: function() {

			// Markers
			$marker.on('click', function(e) {
				e.preventDefault();

				var $this = $(this);
				map.set_overlay_content($this);
			});

			// Overlay Nav
			$ovl_next.add($ovl_prev).on('click', function(e) {
				e.preventDefault();

				var $this = $(this), dir = +1, alt = 'first-child';

				if ($this.hasClass('overlay-prev')) {
					dir = -1;
					alt = 'last-child';
				}

				if ($('.marker-wrap:nth-child(' + (active + dir) + ')').length) {
					map.set_overlay_content($('.marker-wrap:nth-child(' + (active + dir) + ')').children());
				} else {
					map.set_overlay_content($('.marker-wrap:' + alt).children());
				}
			});

			if ($html.hasClass('no-touch')) {
				// Close overlay if clicked elsewhere on the block
				$work_map.on('click', function() {
					if ($ovl.hasClass('open')) {
						map.toggle_overlay();
						$marker.removeClass('active');
					}
				});

				// Prevent overlay closing for certain clicks
				$ovl.add($marker).on('click', function(e) {
					e.stopPropagation();
				});
			} else {
				map.set_overlay_content($marker.first());
			}

		},

		preload_images: function() {
			var preload = [], promises = [], i;

			$marker.each(function() {
				preload.push($(this).data('overlay-image-path'));
			});

			for (i = 0; i < preload.length; i += 1) {
				(function(url, promise) {
					var img = new Image();
					img.onload = function() {
						promise.resolve();
					};

					img.src = url;
				})(preload[i], promises[i] = $.Deferred());
			}
			$.when.apply($, promises).done(function() {
				map.intro();
			});
		},

		intro: function() {
			var intro = setTimeout(function() {

				$marker.each(function(e, i) {
					var $this = $(this), marker;

					marker = setTimeout(function() {
						$this.addClass('loaded');
					}, (60 * e));
				});
				map.init();

				// set a default, this will break we need a better solution
				map.set_overlay_content($($.find('span.marker-wrap.m-8 a')[0]));

			}, 1000);
		},

		// Opens/Closes overlay
		toggle_overlay: function() {
			$ovl.toggleClass('open');
		},

		// Populates overlay
		set_overlay_content: function($el) {

			// Update global active
			active = ($el.parent().index()) + 1;

			// Set marker class to active
			$marker.removeClass('active');
			$el.addClass('active');

			// Get content
			var ovl_heading = $el.data('overlay-heading'),
				ovl_image = $el.data('overlay-image-path'),
				ovl_content = $el.data('overlay-content'),
				ovl_link = $el.data('overlay-link'),
				ovl_filter_overlay = $el.data('overlay-filter-overlay'),
				// Set delay
				x = 0;

			// Determine overlay state
			if (!$ovl.hasClass('open')) {
				map.toggle_overlay();
			} else {
				$ovl.addClass('changing');
				x = 168;
			}

			// Change overlay content
			setTimeout(function() {
				$ovl_image.css('background-image', 'url(' + ovl_image + ')');
				$ovl_heading.text(ovl_heading);
				$ovl_content.text(ovl_content);

				if (ovl_link.length > 0) {
					$ovl_link.attr('href', ovl_link);
				} else {
					$ovl_link.removeAttr('href');
				}

				$ovl_filter_overlay.removeClass();
				$ovl_filter_overlay.addClass(ovl_filter_overlay);

				$ovl.removeClass('changing');
			}, x);

		}
	};

	if ($('.work-map').length) {
		// Preload images before loading map content
		map.preload_images();
	}

});
